class WishlistShare extends HTMLElement {
  connectedCallback () {
    this.setupListeners()
  }

  setupListeners () {
    this.modalTriggers.forEach(trigger => {
      trigger.addEventListener('click', this.toggleModal.bind(this))
    })

    this.shareListTrigger.addEventListener('click', this.handleShare.bind(this))
  }

  toggleModal () {
    const isVisible = this.modal.getAttribute('aria-hidden') === 'false'

    this.modal.setAttribute('aria-hidden', isVisible)
    this.dataset.modalActive = isVisible ? 'false' : 'true'
  }

  async handleShare (event) {
    const wishlistId = event.target.closest('[data-wishlist-id]').dataset.wishlistId
    const listPublic = await this.markListPublic(wishlistId)

    if (!listPublic) {
      this.querySelector('button').textContent = this.dataset.textDefault
    }

    const params = {
      toEmailId: this.recipientEmail,
      fromName: this.dataset.customerName,
      note: this.note,
      lid: wishlistId,
    }

    const onSuccess = function (response) {
      console.log('Successfully sent the wishlist contents via Email', response)
    }

    const onError = function (error) {
      console.error('There was an Error Sending the email', error)
    }

    window._swat?.sendListViaEmail(params, onSuccess, onError)
    this.toggleModal()
  }

  markListPublic (wishlistId) {
    return new Promise((resolve) => {
      const onSuccess = function (wishlists) {
        resolve(true)
      }
      const onError = function (error) {
        console.error('markListPublic() - Error', error)
      }

      window._swat.markListPublic(
        wishlistId,
        onSuccess,
        onError,
      )
    })
  }

  get modal () {
    return this.querySelector('[data-wishlist-share-el="modal"]')
  }

  get recipientEmail () {
    return this.querySelector('[data-wishlist-share-el="email"]').value
  }

  get note () {
    const noteEl = this.querySelector('[data-wishlist-share-el="note"]')

    return noteEl.value || noteEl.placeholder
  }

  get shareListTrigger () {
    return this.querySelector('[data-wishlist-share-el="share"]')
  }

  get modalTriggers () {
    const localTriggers = this.querySelectorAll('[data-wishlist-share-el="trigger"]')
    const externalTriggers = document.querySelectorAll('[data-wishlist-share-external-el="trigger"]')

    return [...localTriggers, ...externalTriggers]
  }
}

customElements.define('wishlist-share', WishlistShare)
